import * as React from 'react'

import { Small } from 'main/ui'
// import { moreInformationHref } from './constants'
import EditButton from './EditButton'
import { Container, TopRowContainer } from './MobileView.styles'

interface IProps {
  onRequestEdit: () => void
}

export default function MobileView(props: IProps) {
  const { onRequestEdit } = props

  return (
    <Container>
      <TopRowContainer>
        <Small>Would you like to edit your website?</Small>
        {/* TODO (aboltunov): unhide when we have a url to link to */}
        {/* <MoreInformationNativeLink href={moreInformationHref}>
          More information
        </MoreInformationNativeLink> */}
      </TopRowContainer>
      <EditButton onClick={onRequestEdit} />
    </Container>
  )
}
